/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetDogmaAttributesAttributeIdNotFound
 */
export interface GetDogmaAttributesAttributeIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetDogmaAttributesAttributeIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetDogmaAttributesAttributeIdNotFound interface.
 */
export function instanceOfGetDogmaAttributesAttributeIdNotFound(value: object): value is GetDogmaAttributesAttributeIdNotFound {
    return true;
}

export function GetDogmaAttributesAttributeIdNotFoundFromJSON(json: any): GetDogmaAttributesAttributeIdNotFound {
    return GetDogmaAttributesAttributeIdNotFoundFromJSONTyped(json, false);
}

export function GetDogmaAttributesAttributeIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDogmaAttributesAttributeIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetDogmaAttributesAttributeIdNotFoundToJSON(json: any): GetDogmaAttributesAttributeIdNotFound {
    return GetDogmaAttributesAttributeIdNotFoundToJSONTyped(json, false);
}

export function GetDogmaAttributesAttributeIdNotFoundToJSONTyped(value?: GetDogmaAttributesAttributeIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

